import React from 'react';
import { LinkV2 } from '../LinkV2';
import { BrandFacebookIcon } from '../SvgIconsV3/BrandFacebook';
import { BrandPinterestIcon } from '../SvgIconsV3/BrandPinterest';
import { BrandTwitterIcon } from '../SvgIconsV3/BrandTwitter';
import { BrandInstagramIcon } from '../SvgIconsV3/BrandInstagram';
import { BrandTiktokIcon } from '../SvgIconsV3/BrandTiktok';

const SocialIcons = (): JSX.Element => {
  return (
    <ul className="social-icons">
      <li>
        <LinkV2
          href="https://www.facebook.com/zola"
          aria-label="Facebook"
          target="_blank"
          rel="noopener noreferrer"
          subtle
          noUnderline
        >
          <BrandFacebookIcon title="Facebook" aria-hidden="true" height={20} width={20} />
        </LinkV2>
      </li>
      <li>
        <LinkV2
          href="https://www.pinterest.com/zola"
          aria-label="Pinterest"
          target="_blank"
          rel="noopener noreferrer"
          subtle
          noUnderline
        >
          <BrandPinterestIcon title="Pinterest" aria-hidden="true" height={20} width={20} />
        </LinkV2>
      </li>
      <li>
        <LinkV2
          href="https://www.twitter.com/zola"
          aria-label="Twitter"
          target="_blank"
          rel="noopener noreferrer"
          subtle
          noUnderline
        >
          <BrandTwitterIcon title="Twitter" aria-hidden="true" height={20} width={20} />
        </LinkV2>
      </li>
      <li>
        <LinkV2
          href="https://www.instagram.com/zola"
          aria-label="Instagram"
          target="_blank"
          rel="noopener noreferrer"
          subtle
          noUnderline
        >
          <BrandInstagramIcon title="Instagram" aria-hidden="true" height={20} width={20} />
        </LinkV2>
      </li>
      <li>
        <LinkV2
          href="https://www.tiktok.com/@zola"
          aria-label="TikTok"
          target="_blank"
          rel="noopener noreferrer"
          subtle
          noUnderline
        >
          <BrandTiktokIcon
            title="TikTok"
            className="zola-icon-a"
            aria-hidden="true"
            height={20}
            width={20}
          />
        </LinkV2>
      </li>
    </ul>
  );
};

export default SocialIcons;
